<style scoped>
.vx-echarts {
  width: 100%;
  background-color: #fff;
}
</style>

<template>
  <div class="vx-echarts"></div>
</template>

<script>
import { getEcharts } from "@mlib/js/get-libs/index.js";

export default {
//   name: "vx-echarts",
  props: {
    option: {
      type: Object,
      default() {
        return {};
      },
      required: true,
    },
    action: {
      type: [Array, Object],
      default() {
        return [];
      },
      required: false,
    },
    // 是否正在加载中
    isloading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  methods: {
    // 销毁实例
    dispose() {
      this.chart && this.chart.dispose();
    },
    // 改变图表尺寸，在容器大小发生改变时调用。
    resize() {
      this.chart && this.chart.resize();
    },
    // 选项改变，重渲
    setCharts() {
      if (this.option) {
        // this.chart.setOption(Object.assign({ color: COLOR }, this.option));
        this.chart.dispatchAction({
          type: 'hideTip'
        })

        this.chart.setOption(this.option);

        if (this.action instanceof Array) {
          this.action.forEach((item) => this.chart.dispatchAction(item));
        } else if (this.action) {
          this.chart.dispatchAction(this.action);
        }
      }
    },
    init() {
      getEcharts().then((echarts) => {
        this.chart = echarts.init(this.$el);
        this.changeLoading();
        this.setCharts();
      });
    },
    // 展示或隐藏加载动画
    changeLoading() {
      let action = this.isloading ? "showLoading" : "hideLoading";

      this.chart && this.chart[action]();
    },
  },
  created() {},
  mounted() {},
  destroy() {
    this.dispose();
  },
  watch: {
    option: {
      immediate: true,
      deep: true,
      handler: function(nv, ov) {
        if (!this.chart) {
          this.init();
        } else {
          this.setCharts();
        }
      },
    },
    isloading: {
      handler: function(nv, ov) {
        this.changeLoading();
      },
    },
  },
};
</script>